import { Guid } from "@/Common/Models/Guid";

class PredefinedRuleSet {
    public ID: string;
    public StartDate: string;
    public EndDate: string;
    public SiteId: Guid;
    public EmployeeId: Guid;
    public Status: string;
    public CreatedByEmployeeId: Guid;
    public CreatedDate: string;

    public PredefinedRuleSetItems: PredefinedRuleSetItem[];
    public PredefinedRuleSetSlots: PredefinedScheduleRuleSetSlotDTO[];

    public DateStartDate: Date;
    public DateEndDate: Date;

    public IsBookingHubAvailability: boolean;
}

class PredefinedRuleSetItem {
    public ID: string;
    public ServiceDefinitionId: string;
    public ComboId: string;
    public Min: number;
    public Max: number;
    public CurrentAmount: number;
    public Status: string;
    public PredefinedScheduleRuleSetId: string;
    public IsOnlineBookingAllowed: boolean;
    public IsUrgent: boolean;
    public TargetedClient: number;
    public ServiceNameLookupId: string;
    public DurationMinutes: number;
    public GroupMax: number;
    public IsTeleconsultation: boolean;

    public DisplayName: string;
    public DisplayDuration: string;
    public DisplayImages: string;
    public DisplayCounters: string;
}

class PredefinedScheduleRuleSetSlotDTO {
    public ID: string;
    public StartDate: string;
    public EndDate: string;
    public EmployeeId: string;
    public PredefinedScheduleRuleSetId: string;
}

export { PredefinedRuleSet, PredefinedRuleSetItem, PredefinedScheduleRuleSetSlotDTO };
